import {
  resourceState,
  resourceMutations,
  resourceGetters,
  resourceActions,
} from '@/store/utils/resource';
import { PIPELINE_STAGES } from '@/store/entities/schema_types';
import { contactRequestPipelineStageClient as client } from '@/api/clients';
import mapKeysToSnakeCase from '@/utils/map-keys-to-snake-case';

export default {
  namespaced: true,
  state: resourceState(),
  mutations: resourceMutations,
  getters: resourceGetters(PIPELINE_STAGES),
  actions: {
    ...resourceActions,
    async read(ctx, { id, query = {} }) {
      try {
        const response = await client.read(id, query);

        const { data } = response;

        const pipelineStageId = await ctx.dispatch(
          'entities/persistEntities',
          { type: PIPELINE_STAGES, data },
          { root: true }
        );

        ctx.commit({
          type: 'setIdByParent',
          parentId: id,
          id: pipelineStageId,
        });

        return Promise.resolve({ pipelineStageId });
      } catch (error) {
        const { response } = error;

        return Promise.reject(response);
      }
    },
    async update(ctx, { id, formData }) {
      try {
        await client.update(id, mapKeysToSnakeCase(formData));

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
